"use client";

import { useEffect } from "react";

/**
 * Root-level error boundary. Catches errors escaping from the root
 * layout (which `app/error.js` can't handle because it depends on
 * the layout being intact). Must render its own <html>/<body>.
 */
export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error("[global error]", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', sans-serif",
          background: "#f5f5f6",
          color: "#1d1d1f",
        }}
      >
        <main
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            padding: "2rem",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", margin: 0 }}>
            Something went wrong.
          </h1>
          <p style={{ maxWidth: 480, margin: 0, opacity: 0.7 }}>
            We hit an unexpected error. Please refresh the page.
          </p>
          <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.5rem" }}>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                padding: "0.7rem 1.25rem",
                borderRadius: 999,
                border: "1px solid rgba(0,0,0,0.12)",
                background: "#1d1d1f",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Try again
            </button>
            <a
              href="/"
              style={{
                padding: "0.7rem 1.25rem",
                borderRadius: 999,
                border: "1px solid rgba(0,0,0,0.12)",
                background: "transparent",
                color: "#1d1d1f",
                textDecoration: "none",
              }}
            >
              Back to home
            </a>
          </div>
        </main>
      </body>
    </html>
  );
}
